export const formatDate = (date) => {
    const aux = new Date(date)
    const day = String(aux.getDate()).padStart(2, '0')
    const month = String(aux.getMonth()).padStart(2, '0')
    const year = aux.getFullYear()

    return `${day}/${month}/${year}`
}